module.exports = __webpack_public_path__ + "img/fuelCalc.d4397456.png";